<template>
  <div id="app">
    <router-view v-if="!isMobile" name="pcheader"></router-view>
    <router-view v-else name="spheader" :back-handler="backHandler" :action-handler="actionHandler" :enableButton="enableButton" :buttonName="buttonName"></router-view>
    <div class="wrapper">
      <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
      <div class="page-cnt">
        <router-view name="sidebar"/>
        <router-view v-if="!isMobile" name="pcbody"/>
        <router-view v-else @update:backHandler="backHandler = $event" @update:actionHandler="actionHandler = $event" v-on:enableButton="setButton" name="spbody"/>
      </div>
    </div>
    <router-view v-if="!isMobile" name="pcfooter"></router-view>
    <router-view v-else name="spfooter"></router-view>
    <loading v-if="isLoading"/>
  </div>
</template>

<script>
/* global $ */
import MobileDetect from 'mobile-detect';
import { mapState, mapActions } from 'vuex';
import loading from "@/views/common/Loading";
import { EventBus } from '@/helpers/event-bus.js';

export default {
    name: 'App',
    components: {
        loading,
    },
    computed: {
        ...mapState(['alert', 'isLoading', 'refCount']),
    },
    data () {
        return {
            isMobile: false,
            backHandler: () => { this.$router.go(-1); },
            actionHandler: () => {},
            enableButton: false,
            buttonName: "",
        };
    },
    created () {
        this.checkIsMobile();

        EventBus.$on('NetworkError', event => {
            let msg = this.$root.$t("error.error_network");
            this.$toasted.error(msg, {});
        });
        EventBus.$on('timeoutApi', event => {
            let msg = this.$root.$t("error.error_timeout");
            this.$toasted.error(msg, {});
        });
    },
    mounted () {
        var isMobile = new MobileDetect(window.navigator.userAgent);
        const nodeEnv = process.env.NODE_ENV;
        if (isMobile.mobile()) {
            require('@/assets/css/main_sp.css');
            if (nodeEnv == "development" || nodeEnv == "staging") {
                require('@/assets/css/dev/header_sp.css');
                require('@/assets/css/dev/login_sp.css');
            } else {
                require('@/assets/css/prod/header_sp.css');
                require('@/assets/css/prod/login_sp.css');
            }
        } else {
            require('@/assets/css/main.css');
            if (nodeEnv == "development" || nodeEnv == "staging") {
                require('@/assets/css/dev/header_pc.css');
                require('@/assets/css/dev/login_pc.css');
            } else {
                require('@/assets/css/prod/header_pc.css');
                require('@/assets/css/prod/login_pc.css');
            }
        }
        require('@/assets/css/custom.css');
    },
    methods: {
        checkIsMobile () {
            console.log('checkIsMobile: ' + window.navigator.userAgent);
            var isMobile = new MobileDetect(window.navigator.userAgent);
            if (isMobile.mobile()) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }
        },
        setButton (value) {
            if (value) {
                this.enableButton = true;
                this.buttonName = value;
            } else {
                this.enableButton = false;
                this.buttonName = "";
            }
        },
        ...mapActions({
            clearAlert: 'alert/clear',
        }),
    },
    watch: {
        $route (to, from) {
            // clear alert on location change
            this.clearAlert();
            this.backHandler = () => { this.$router.go(-1); };
            this.disable = false; // re-enable OK button
            $('.modal-backdrop').remove();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/App.vue